import React, { FC, memo, useEffect } from 'react';
import { useConnect } from './connect';
import PremiumResourcesView from './View';

const PremiumResources: FC = () => {
  const { getOfficeHours, officeHours } = useConnect();

  useEffect(() => {
    getOfficeHours();
  }, [getOfficeHours]);

  return <PremiumResourcesView officeHours={officeHours} />;
};

export default memo(PremiumResources);
